import(/* webpackMode: "eager", webpackExports: ["default"] */ "/mnt/data/opt/node/penzu-next/components/newsletter-form-simple.tsx");
;
import(/* webpackMode: "eager" */ "/mnt/data/opt/node/penzu-next/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/mnt/data/opt/node/penzu-next/node_modules/next/dist/client/image-component.js");
